module.exports = __webpack_public_path__ + "img/boba-network.49a0374a.png";